<template>
  <b-form-group
    label="Telefon"
    label-for="phone"
  >
    <b-form-input
      id="phone"
      v-model="dataItem.phone"
      placeholder="Telefon"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'PhoneNumber',
  components: {
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['tenants/dataItem']
    },
  },
}
</script>
